import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const Step2Paciente = ({ formData, updateFormData }) => {
  return (
    <div className="space-y-6">
      <div className="bg-green-50 p-4 rounded-lg border border-green-200">
        <h3 className="text-lg font-semibold text-[#505BB3] mb-4">Datos del Paciente</h3>
        
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="nombrePaciente">Nombre *</Label>
            <Input
              id="nombrePaciente"
              type="text"
              placeholder="Nombre del paciente"
              value={formData.nombrePaciente}
              onChange={(e) => updateFormData('nombrePaciente', e.target.value)}
              required
              className="border-gray-300 focus:border-[#505BB3] focus:ring-[#505BB3]"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="especie">Especie *</Label>
              <Select 
                value={formData.especie} 
                onValueChange={(value) => updateFormData('especie', value)}
              >
                <SelectTrigger className="border-gray-300 focus:border-[#505BB3] focus:ring-[#505BB3]">
                  <SelectValue placeholder="Seleccione la especie" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Canino">Canino</SelectItem>
                  <SelectItem value="Felino">Felino</SelectItem>
                  <SelectItem value="Ave">Ave</SelectItem>
                  <SelectItem value="Reptil">Reptil</SelectItem>
                  <SelectItem value="Roedor">Roedor</SelectItem>
                  <SelectItem value="Otro">Otro</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label htmlFor="edad">Edad *</Label>
              <Input
                id="edad"
                type="text"
                placeholder="Ej: 3 años, 6 meses"
                value={formData.edad}
                onChange={(e) => updateFormData('edad', e.target.value)}
                required
                className="border-gray-300 focus:border-[#505BB3] focus:ring-[#505BB3]"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="raza">Raza *</Label>
            <Input
              id="raza"
              type="text"
              placeholder="Raza del paciente"
              value={formData.raza}
              onChange={(e) => updateFormData('raza', e.target.value)}
              required
              className="border-gray-300 focus:border-[#505BB3] focus:ring-[#505BB3]"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="sexo">Sexo *</Label>
            <Select 
              value={formData.sexo} 
              onValueChange={(value) => updateFormData('sexo', value)}
            >
              <SelectTrigger className="border-gray-300 focus:border-[#505BB3] focus:ring-[#505BB3]">
                <SelectValue placeholder="Seleccione el sexo" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Macho">Macho</SelectItem>
                <SelectItem value="Hembra">Hembra</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="propietario">Propietario</Label>
            <Input
              id="propietario"
              type="text"
              placeholder="Nombre del propietario"
              value={formData.propietario}
              onChange={(e) => updateFormData('propietario', e.target.value)}
              className="border-gray-300 focus:border-[#505BB3] focus:ring-[#505BB3]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step2Paciente;